import { render, staticRenderFns } from "./NisYourScore.vue?vue&type=template&id=8bcd86c8&scoped=true"
import script from "./NisYourScore.vue?vue&type=script&lang=js"
export * from "./NisYourScore.vue?vue&type=script&lang=js"
import style0 from "./NisYourScore.vue?vue&type=style&index=0&id=8bcd86c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcd86c8",
  null
  
)

export default component.exports